import React from 'react';

const IconAngleDown: React.FC<JSX.IntrinsicElements['svg']> = (props) => (
  <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg" {...props}>
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M19.4727 7.01624C19.7288 6.72667 20.1712 6.69959 20.4608 6.95574C20.7503 7.21189 20.7774 7.65428 20.5213 7.94384L12.5243 16.9838C12.2457 17.2988 11.7543 17.2988 11.4757 16.9838L3.47881 7.94384C3.22266 7.65428 3.24975 7.21189 3.53931 6.95574C3.82887 6.69959 4.27126 6.72667 4.52741 7.01624L12 15.4636L19.4727 7.01624Z"
      fill="currentColor"
    />
  </svg>
);

export default IconAngleDown;
